export default __webpack_public_path__ + "static/media/gold-wheel.4d18b558.png";